import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ApiResponse, BaseApiService } from '../../api/base';
import { Company } from '@models/company';
import { OperationResult } from '@models/operation-result';
import { AuthService } from '@core/auth/auth.service';
import { DeleteUser, DropdownOption, StatusOptions } from '@models/forms';
import { User } from '@models/user';
import { Nullable } from '@models/nullable';
import { HttpParams } from '@angular/common/http';
import { Prompt, PromptCategory } from '@core/components/prompt-component/prompt.component';

export type PromptAPIResponse = {
  promptCategoryId: number,
  promptId: number,
  promptText: string,
  title: string,
  user: User,
  userId: number
}

export type PromptCategoryAPIResponse = {
  id: number,
  promptCategoryId: number,
  category: string,
}


@Injectable({
  providedIn: 'root'
})
export class PromptService extends BaseApiService<Company> {

  constructor(authService: AuthService, router: Router, messageService: MessageService) {
    super('/prompt', authService, router, messageService);
  }

  getPromptsCategories( ): Observable<ApiResponse<PromptCategoryAPIResponse[]>> {
    return this.get(`/categories`);
  }
  
  getPrompts(id?: number, searchTerm?: string): Observable<ApiResponse<PromptAPIResponse[]>> {
    let queryParams: string[] = [];
  
    if (id !== undefined) {
      queryParams.push(`categoryId=${id}`);
    }
  
    if (searchTerm !== undefined) {
      queryParams.push(`searchTerm=${encodeURIComponent(searchTerm)}`);
    }
  
    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
  
    return this.get(queryString);
  }
  
  addPrompt(prompt: any): Observable<ApiResponse<any>>{
    return this.post(``, null, {promptCategoryId: prompt.category.value, promptText: prompt.description, title: prompt.name});
  }
}